(function($) {

  //frontpage site list - calculate min-height for images
  function calcCoverImgHeight(){
    var $txt, minH, $elements;

    $elements = $('.teaser.type-site .img-full-screen');

    if($elements.length == 0) {
      return;
    }

    $elements.removeClass('recalculated');
    $elements.css({'min-height': 0});

    $.each($elements, function( ind, el ) {

      $txt = $('.header', el);
      elH = $(el).height();
      minH = $txt.outerHeight();

      if(elH < minH) {
        $(el).addClass('recalculated');
        $(el).css({'min-height': minH});
      }

    });
  }

  // accordeon element heights
  function initAccordeonHeight() {
    var $accordeon = $('.accordeon');

    if($accordeon.length == 0) {
      return;
    }

    var minH;

    $.each($accordeon, function( ind, el ) {
      minH = $('.accordeon-content', el).outerHeight();
      $(el).css('maxHeight', minH);
    });

  }

  // accordeon toggle function
  function initAccordeonClick() {
    var $button = $('button.expand');

    if($button.length == 0) {
      return;
    }

    var id, $accordeon;

    $button.on('click', function(){
      var $this = $(this);
      id = $this.attr('data-target');
      $accordeon = $('#' + id);
      $accordeon.toggleClass('collapsed');

      $('body').animate({
        scrollTop: $accordeon.offset().top
      }, 500);

      $this.toggleClass('expanded');
    });
  }

  // init mmenu
  function initMmenu(){
    var isOpen = false;

    $('#site-navigation').mmenu({
      'slidingSubmenus': false,
      'pageScroll': true,
      'extensions': [
        'pagedim-white'
      ],
      offCanvas: {
        position: 'right',
        zIndex: 'back'
      },
      pageScroll: {
        scroll: true,
        update: true
      }
    }, {
      clone: true,
      offCanvas: {
        pageSelector: '#page',
      },
      pageScroll: {
        scrollOffset:	-50,
        updateOffset: 50
      }
    });

    var API = $('#mm-site-navigation').data( 'mmenu' );

    var $closeBtn = $('#menu-close');
    $closeBtn.on('click', function(){
      API.close();
    });

    $('#menu-toggle').on('click', function(){
      API.open();
    });

  }

  // init qtip
  function initJuryQtips() {
    var $juror = $('article.type-jury');
    var winH = $(window).height();

    var $viewport = $(document);

    if(winH > 750) {
      $viewport = $(window);
    }

    if($juror.length == 0) {
      return;
    }

    $juror.qtip({
      show: {
        event: 'mouseenter touchend',
        solo: true
      },
      hide: {
        event: 'mouseleave unfocus'
      },
      content: {
        text: function(){
          return $('.content', this).clone();
        }
      },
      position: {
        my: 'top center',
        at: 'bottom center',
        viewport: $viewport,
        adjust: {
          method: 'shift none'
        }
      },
      style: {
        tip: {
          corner: true,
          width: 30,
          height: 14
        },
        classes: 'qtip-europan'
      },
      events: {
        visible: function(event, api) {
          api.target.addClass('hovered');
        },
        hidden: function(event, api) {
          api.target.removeClass('hovered');
        }
      }
    });
  }

  // init modals
  var modal;
  function qtipModal(modaContent) {
    modal = $('<div id="qtip-modal" />').qtip({
      content: {
        text: modaContent,
        button: true
      },
      position: {
        my: 'top center',
        at: 'top center',
        target: $(window),
        adjust: {
          y: 40,
          scroll: false
        }
      },
      show: {
        ready: true,
        modal: {
          on: true,
          blur: true
        },
        solo: true
      },
      hide: false,
      style: {
        classes: 'modal-europan',
        tip: false
      },
      events: {
        show: function(event, api) {
        },
        render: function(event, api) {
          flexslider();
        },
        hide: function(event, api) {
          // Remove hash for modal links.
          window.location.hash = '_';

          api.destroy();
        },
        blur: function(event, api) {
        }
      }
    });
  }

  function initModalLinks() {
    var $links = $('a.modal-link');
    var url, $loader;

    if($links.length == 0) {
      return;
    }

    $links.on('click', function(event){
      event.preventDefault();
      url = $(this).attr('href');
      openModal(url);
    });
  }

  // Open modal helper function.
  function openModal(url) {
    $('body').prepend('<div id="europan-loader"><div></div></div>');

    $.ajax({ url: url })
    .done(function(html) {
      $('#europan-loader').remove();
      content = $(html).find('article').first();
      qtipModal(content);

      // Add modal target URL into hash.
      var urlParameter = url.replace(window.location.origin, '');
      var newHash = 'modal=' + urlParameter;
      window.location.hash = newHash;
    })
    .fail(function(xhr, status, error) {
      $('#europan-loader').remove();
      content = '<div class="error">' + status + ': ' + error + '</div>';
      qtipModal(content);
    });
  }

  // calculate jury bg gradient size
  function calcJuryBGSize() {
    var $jury = $('article.type-jury');
    var juryW, juryWOuter, juryHOuter, juryWMargin;

    if($jury.length == 0) {
      return;
    }

    juryW = $jury.first().width() - 4;
    juryWOuter = $jury.first().outerWidth(true);
    juryHOuter = $jury.first().outerHeight(true);
    juryWMargin = (juryWOuter - juryW) * 0.5;

    var left2 = juryWMargin / juryWOuter;
    var left3 = (juryWMargin + juryW) / juryWOuter;
    var top2 = juryW / juryHOuter;

    $('div.jury').css('background-size', juryWOuter + 'px ' + juryWOuter + 'px');

    // webkit fixed
    var gradient = '-webkit-gradient(linear, left top, right top, color-stop(0, #fff), color-stop(' + left2 + ', #fff), color-stop(' + left2 + ', transparent), color-stop(' + left3 + ', transparent), color-stop(' + left3 + ', #fff)),-webkit-gradient(linear, left top, left bottom, color-stop(0, transparent), color-stop(' + top2 + ', transparent), color-stop(' + top2 + ', #fff))';
    $('div.jury').css('background-image', gradient);
  }

  // Archive page. Opens submenus.
  function archiveList() {
    var $archiveList = $('.archive-list');
    if ($archiveList[0]) {
      $archiveList.find('.archive-list__event-name').click(function() {
        $(this).siblings('.archive-list__city-list').toggleClass('is-open');
      });
    }
  }

  // Simple helper function to init flexslider.
  function flexslider() {
    $('.flexslider').flexslider({
      controlNav: false
    });
  }

  // Automatically get menu links on front-page.
  function setMenuLinks() {
    if ($('body.home').length) {
      var $sections = $('article').first().children('section');

      var $linkList = $('<ul>');
      $linkList.addClass('mm-listview mm-listview--automated');

      $sections.each(function() {
        var title = null;
        var id = $(this).attr('id');
        var hasMenuLabel = (typeof $(this).attr('menu-label') !== typeof undefined && $(this).attr('menu-label') !== false);
        if (hasMenuLabel) {
          title = $(this).attr('menu-label');
        }
        else if ($(this).children('h1').length) {
          title = $(this).children('h1').text();
        }
        else {
          title = id;
        }

        $linkList.append('<li><a href="#' + id + '">' + title + '</a></li>');
      });

      //$('.menu-main-menu-container').prepend($linkList);
      $('.mm-panels').prepend($linkList);
    }
  }

  // Check url hash and open modals if found.
  function openUrlModal() {
    var hash = window.location.hash.substring(1);
    if (hash.indexOf('modal=') == 0) {
      var hashUrl = hash.replace('modal=', '');
      var url = window.location.origin + hashUrl
      openModal(url);
    }
  }

  // front page carousel
  function initFrontpageSlider() {
    $('#flexslider-front').flexslider({
      animation: 'fade',
      animationLoop: true,
      slideshow: true,
      slideshowSpeed: 2500,
      directionNav: false,
      keyboard: false,
      controlNav: false,
      randomize: true,
      pauseOnHover: false,
      pauseOnAction: false
    });
  }

  function initImageGallery(){
    $('.img-list').magnificPopup({
      delegate: 'li', // child items selector, by clicking on it popup will open
      type: 'image',
      gallery: {
        enabled: true
      }
    });
  }

  $(document).ready(function(){
    initMmenu();
    initModalLinks();
    archiveList();
    setMenuLinks();
    openUrlModal();
    initImageGallery();
  });

  $(window).load(function(){
    calcCoverImgHeight();
    initAccordeonHeight();
    initAccordeonClick();
    initFrontpageSlider();
    initJuryQtips();
    calcJuryBGSize();
    flexslider();
  });

  $(window).resize(function(){
    calcCoverImgHeight();
    initAccordeonHeight();
    calcJuryBGSize();
  });

})(jQuery);
